import { useAnimation } from '../../../hooks/useAnimation';
import Navigation from '../../../components/feature/Navigation';
import { Link } from 'react-router-dom';

export default function LocationEnvironmentPage() {
  const heroRef = useAnimation('fade-in');
  const section1Ref = useAnimation('fade-in', 100);
  const section2Ref = useAnimation('slide-up', 150);
  const section3Ref = useAnimation('slide-up', 200);
  const section4Ref = useAnimation('slide-up', 250);
  const section5Ref = useAnimation('slide-up', 300);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section
        ref={heroRef}
        className="relative h-[180px] md:h-[320px] flex items-center justify-center mt-16 md:mt-20 overflow-hidden"
        style={{
          backgroundImage:
            "url('https://public.readdy.ai/ai/img_res/f03e78d12205732de6e7806daf469112.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
        }}
      >
        <div className="absolute inset-0 bg-[#0d1b3e]/70"></div>
        <div className="relative z-10 text-center text-white px-4">
          <h1
            className="text-[18px] md:text-[44px] font-bold leading-tight"
            style={{ fontFamily: "'Noto Serif KR', serif" }}
          >
            입지환경
          </h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <div className="bg-[#f5f6f8] border-b border-gray-200">
        <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center gap-2 text-[10px] md:text-[12px] text-gray-500">
          <span>홈</span>
          <i className="ri-arrow-right-s-line"></i>
          <span>입지안내</span>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-[#1a2b5c] font-semibold">입지환경</span>
        </div>
      </div>

      {/* Section Title */}
      <section ref={section1Ref} className="pt-8 md:pt-12 pb-4 md:pb-6 px-4 bg-white text-center">
        <p className="text-[10px] md:text-[15px] text-gray-500 mb-2">입주민으로 누릴수 있는 모든것이</p>
        <h2
          className="text-[16px] md:text-[32px] font-bold text-[#1a2b5c] leading-tight"
          style={{ fontFamily: "'Noto Serif KR', serif" }}
        >
          "특권이 되는 센트럴 청주의 압도적 입지"
        </h2>
        <p className="mt-2 md:mt-3 text-[10px] md:text-[14px] text-gray-500 leading-relaxed max-w-2xl mx-auto">
          CTX(예정), 현대학고속터미널 등을 통한 압도적인 광역교통망 구축의 핵심위치
          <br />
          커넥트현대(현대프리미엄아울렛), 메가박스 MX관(중부권 최초), NC백화점, 롯데마트 등 압도적인 편의시설
        </p>
      </section>

      {/* Map + Side Info */}
      <section ref={section2Ref} className="py-6 md:py-8 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="border border-gray-200 rounded-xl overflow-hidden shadow-md">
            <div className="flex flex-col md:flex-row">
              {/* Map */}
              <div className="md:w-[60%] bg-gray-100">
                <img
                  src="https://static.readdy.ai/image/3b7ebc9e513f68fc027b047fbdd0fbe7/2ffa6a58a255dc1af0b6d3e85fb8abf8.png"
                  alt="입지환경 지도"
                  className="w-full h-full object-cover"
                  style={{ minHeight: '180px', maxHeight: '420px' }}
                />
              </div>
              {/* Right Info */}
              <div className="md:w-[40%] flex flex-col">
                {/* CTX */}
                <div className="flex-1 border-b border-gray-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20sleek%20blue%20CTX%20commuter%20express%20train%20at%20station%20platform%20South%20Korea%2C%20high%20speed%20rail%20with%20clean%20design%2C%20professional%20railway%20photography%20with%20sharp%20details%20and%20dramatic%20lighting&width=600&height=200&seq=ctx-train-side-001&orientation=landscape"
                    alt="CTX 열차"
                    className="w-full h-[100px] md:h-[160px] object-cover object-top"
                  />
                  <div className="px-3 md:px-4 py-2 md:py-3 bg-white">
                    <p className="text-[10px] md:text-[13px] font-bold text-[#1a2b5c]">
                      청주의 광역·지역교통 핵심HUB
                    </p>
                    <p className="text-[9px] md:text-[12px] text-gray-500 mt-1 leading-relaxed">
                      CTX(예정), 현대학고속터미널 등을 통한
                      <br />
                      압도적인 광역교통망 구축의 핵심위치
                    </p>
                  </div>
                </div>
                {/* Shopping */}
                <div className="flex-1">
                  <img
                    src="https://readdy.ai/api/search-image?query=Luxurious%20modern%20premium%20outlet%20shopping%20mall%20interior%20with%20multiple%20floors%2C%20elegant%20architecture%20featuring%20bright%20natural%20lighting%2C%20sophisticated%20retail%20space%20with%20high%20ceilings%20and%20contemporary%20design%2C%20premium%20lifestyle%20shopping%20environment%20Korea&width=600&height=200&seq=shopping-side-001&orientation=landscape"
                    alt="쇼핑몰"
                    className="w-full h-[100px] md:h-[160px] object-cover object-top"
                  />
                  <div className="px-3 md:px-4 py-2 md:py-3 bg-white">
                    <p className="text-[10px] md:text-[13px] font-bold text-[#1a2b5c]">
                      편리한 생활, 완성된 인프라
                    </p>
                    <p className="text-[9px] md:text-[12px] text-gray-500 mt-1 leading-relaxed">
                      커넥트현대(현대프리미엄아울렛), 메가박스 MX관(중부권 최초),
                      <br />
                      NC백화점, 롯데마트 등 압도적인 편의시설
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Feature Cards */}
      <section ref={section3Ref} className="py-6 md:py-8 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
            {/* Card 1 - CTX */}
            <div className="rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-all cursor-pointer">
              <div className="relative h-[120px] md:h-[200px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20blue%20high%20speed%20CTX%20express%20train%20arriving%20at%20station%20platform%2C%20sleek%20futuristic%20design%2C%20South%20Korea%20public%20transportation%2C%20dramatic%20lighting%20with%20motion%20blur%20effect%2C%20professional%20railway%20photography&width=600&height=400&seq=ctx-card-001&orientation=landscape"
                  alt="동서울 세계 어디로든 핵심HUB"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0d1b3e]/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                  <p className="text-white text-[11px] md:text-[15px] font-bold leading-tight">
                    동서울 세계 어디로든<br />핵심HUB
                  </p>
                  <p className="text-white/70 text-[9px] md:text-[11px] mt-1">
                    CTX(예정) 현대학고속터미널 인접, 청주국제공항 차량 20분
                  </p>
                </div>
              </div>
            </div>
            {/* Card 2 - Shopping */}
            <div className="rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-all cursor-pointer">
              <div className="relative h-[120px] md:h-[200px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Premium%20outlet%20shopping%20mall%20exterior%20with%20modern%20architecture%2C%20large%20glass%20facade%2C%20elegant%20signage%2C%20wide%20open%20plaza%20with%20people%20walking%2C%20daytime%20photography%20with%20clear%20sky%2C%20upscale%20retail%20destination%20Korea&width=600&height=400&seq=outlet-card-001&orientation=landscape"
                  alt="압도적 쇼핑, 생활편의"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0d1b3e]/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                  <p className="text-white text-[11px] md:text-[15px] font-bold leading-tight">
                    압도적 쇼핑, 생활편의
                  </p>
                  <p className="text-white/70 text-[9px] md:text-[11px] mt-1">
                    커넥트현대, 메가박스 MX관, NC백화점, 롯데마트
                  </p>
                </div>
              </div>
            </div>
            {/* Card 3 - Street */}
            <div className="rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-all cursor-pointer">
              <div className="relative h-[120px] md:h-[200px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Vibrant%20Korean%20commercial%20street%20with%20modern%20buildings%2C%20restaurants%20and%20shops%2C%20evening%20atmosphere%20with%20warm%20lights%2C%20busy%20pedestrian%20walkway%2C%20urban%20lifestyle%20scene%20in%20Cheongju%20city&width=600&height=400&seq=street-card-001&orientation=landscape"
                  alt="활성화된 생활상권"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0d1b3e]/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                  <p className="text-white text-[11px] md:text-[15px] font-bold leading-tight">
                    활성화된 생활상권
                  </p>
                  <p className="text-white/70 text-[9px] md:text-[11px] mt-1">
                    가경동 핵심 상권 도보 5분, 다양한 편의시설
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Transportation Section */}
      <section ref={section4Ref} className="py-8 md:py-10 px-4 bg-[#f5f6f8]">
        <div className="max-w-6xl mx-auto">
          <h2
            className="text-[16px] md:text-[26px] font-bold text-center text-[#1a2b5c] mb-5 md:mb-8"
            style={{ fontFamily: "'Noto Serif KR', serif" }}
          >
            광역 교통망
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6">
            {/* CTX */}
            <div className="bg-[#1a2b5c] rounded-xl p-4 md:p-7 text-white">
              <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
                <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center bg-white/20 rounded-lg">
                  <i className="ri-train-line text-white text-base md:text-lg"></i>
                </div>
                <h3 className="text-[13px] md:text-[18px] font-bold">CTX (예정)</h3>
              </div>
              <ul className="space-y-2 md:space-y-2.5">
                <li className="flex items-start text-[10px] md:text-[14px] text-white/85">
                  <i className="ri-arrow-right-s-fill text-yellow-300 mr-1.5 md:mr-2 mt-0.5 flex-shrink-0 text-sm"></i>
                  <span>서울 동서울터미널 ↔ 청주 CTX 예정역 직결</span>
                </li>
                <li className="flex items-start text-[10px] md:text-[14px] text-white/85">
                  <i className="ri-arrow-right-s-fill text-yellow-300 mr-1.5 md:mr-2 mt-0.5 flex-shrink-0 text-sm"></i>
                  <span>수도권 광역급행 교통망 핵심 거점</span>
                </li>
                <li className="flex items-start text-[10px] md:text-[14px] text-white/85">
                  <i className="ri-arrow-right-s-fill text-yellow-300 mr-1.5 md:mr-2 mt-0.5 flex-shrink-0 text-sm"></i>
                  <span>청주국제공항 차량 약 20분</span>
                </li>
              </ul>
            </div>
            {/* 고속터미널 */}
            <div className="bg-[#1a2b5c] rounded-xl p-4 md:p-7 text-white">
              <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
                <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center bg-white/20 rounded-lg">
                  <i className="ri-bus-2-line text-white text-base md:text-lg"></i>
                </div>
                <h3 className="text-[13px] md:text-[18px] font-bold">현대학고속터미널</h3>
              </div>
              <ul className="space-y-2 md:space-y-2.5">
                <li className="flex items-start text-[10px] md:text-[14px] text-white/85">
                  <i className="ri-arrow-right-s-fill text-yellow-300 mr-1.5 md:mr-2 mt-0.5 flex-shrink-0 text-sm"></i>
                  <span>전국 주요 도시 직행 고속버스 운행</span>
                </li>
                <li className="flex items-start text-[10px] md:text-[14px] text-white/85">
                  <i className="ri-arrow-right-s-fill text-yellow-300 mr-1.5 md:mr-2 mt-0.5 flex-shrink-0 text-sm"></i>
                  <span>서울 강남 고속버스터미널 약 1시간 30분</span>
                </li>
                <li className="flex items-start text-[10px] md:text-[14px] text-white/85">
                  <i className="ri-arrow-right-s-fill text-yellow-300 mr-1.5 md:mr-2 mt-0.5 flex-shrink-0 text-sm"></i>
                  <span>도보 이용 가능한 인접 위치</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Shopping & Lifestyle */}
      <section className="py-8 md:py-10 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2
            className="text-[16px] md:text-[26px] font-bold text-center text-[#1a2b5c] mb-5 md:mb-8"
            style={{ fontFamily: "'Noto Serif KR', serif" }}
          >
            쇼핑 &amp; 라이프스타일
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2.5 md:gap-5">
            {[
              {
                icon: 'ri-store-2-line',
                name: '커넥트현대',
                sub: '프리미엄 아울렛',
                color: 'text-[#1a2b5c]',
                bg: 'bg-[#eef0f7]',
              },
              {
                icon: 'ri-movie-2-line',
                name: '메가박스 MX관',
                sub: '중부권 최초',
                color: 'text-[#c0392b]',
                bg: 'bg-[#fdf0ef]',
              },
              {
                icon: 'ri-building-2-line',
                name: 'NC백화점',
                sub: '차량 5분',
                color: 'text-[#1a6b4a]',
                bg: 'bg-[#eef7f2]',
              },
              {
                icon: 'ri-shopping-cart-2-line',
                name: '롯데마트',
                sub: '도보 10분',
                color: 'text-[#b5600a]',
                bg: 'bg-[#fdf5ec]',
              },
            ].map((item) => (
              <div
                key={item.name}
                className={`${item.bg} rounded-xl p-3 md:p-6 text-center shadow-sm hover:shadow-md transition-all`}
              >
                <div className={`w-9 h-9 md:w-14 md:h-14 ${item.bg} rounded-full flex items-center justify-center mx-auto mb-2 md:mb-3`}>
                  <i className={`${item.icon} text-xl md:text-3xl ${item.color}`}></i>
                </div>
                <p className="text-[11px] md:text-[15px] font-bold text-[#1a2b5c]">{item.name}</p>
                <p className="text-[9px] md:text-[13px] text-gray-500 mt-0.5 md:mt-1">{item.sub}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Education & Medical */}
      <section ref={section5Ref} className="py-8 md:py-10 px-4 bg-[#f5f6f8]">
        <div className="max-w-6xl mx-auto">
          <h2
            className="text-[16px] md:text-[26px] font-bold text-center text-[#1a2b5c] mb-5 md:mb-8"
            style={{ fontFamily: "'Noto Serif KR', serif" }}
          >
            교육 &amp; 의료 인프라
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6">
            {/* 교육 */}
            <div className="bg-white rounded-xl p-4 md:p-7 shadow-sm">
              <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
                <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-[#eef0f7] rounded-lg">
                  <i className="ri-school-line text-[#1a2b5c] text-lg md:text-xl"></i>
                </div>
                <h3 className="text-[13px] md:text-[18px] font-bold text-[#1a2b5c]">교육 환경</h3>
              </div>
              <ul className="space-y-2 md:space-y-2.5">
                {[
                  '가경초등학교 도보 5분',
                  '가경중학교 도보 8분',
                  '청주고등학교 차량 10분',
                  '대형 학원가 도보 7분',
                ].map((item) => (
                  <li key={item} className="flex items-start text-[10px] md:text-[14px] text-gray-700">
                    <i className="ri-checkbox-circle-fill text-[#1a2b5c] mr-1.5 md:mr-2 mt-0.5 flex-shrink-0 text-sm"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            {/* 의료 */}
            <div className="bg-white rounded-xl p-4 md:p-7 shadow-sm">
              <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
                <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-[#fdf0ef] rounded-lg">
                  <i className="ri-hospital-line text-[#c0392b] text-lg md:text-xl"></i>
                </div>
                <h3 className="text-[13px] md:text-[18px] font-bold text-[#1a2b5c]">의료 시설</h3>
              </div>
              <ul className="space-y-2 md:space-y-2.5">
                {[
                  '종합병원 차량 10분',
                  '내과/소아과 의원 도보 5분',
                  '치과/한의원 도보 3분',
                  '24시간 약국 도보 5분',
                ].map((item) => (
                  <li key={item} className="flex items-start text-[10px] md:text-[14px] text-gray-700">
                    <i className="ri-checkbox-circle-fill text-[#c0392b] mr-1.5 md:mr-2 mt-0.5 flex-shrink-0 text-sm"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA - 분양 문의 / 예약 */}
      <section className="py-12 md:py-16 px-4 bg-[#1a2b5c] relative overflow-hidden">
        <div className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: "url('https://readdy.ai/api/search-image?query=elegant%20abstract%20geometric%20pattern%20with%20subtle%20lines%20and%20shapes%2C%20dark%20navy%20blue%20luxury%20background%20texture%2C%20minimalist%20architectural%20detail&width=1400&height=400&seq=cta-bg-pattern-001&orientation=landscape')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>
        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <p className="text-yellow-300 text-[10px] md:text-[14px] tracking-widest mb-2 md:mb-3 font-medium">
            CENTRAL CHEONGJU
          </p>
          <h2
            className="text-[18px] md:text-[36px] font-bold text-white leading-tight mb-3 md:mb-4"
            style={{ fontFamily: "'Noto Serif KR', serif" }}
          >
            센트럴 청주의 특권,<br />지금 바로 확인하세요
          </h2>
          <p className="text-white/70 text-[11px] md:text-[15px] leading-relaxed mb-8 md:mb-10">
            압도적 입지와 프리미엄 생활 인프라를 갖춘 센트럴 청주.<br className="hidden md:block" />
            분양 문의 및 견본주택 방문 예약을 지금 신청하세요.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="/reservation"
              onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion(); }}
              className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-yellow-400 hover:bg-yellow-300 text-[#1a2b5c] font-bold text-[12px] md:text-[16px] px-6 md:px-8 py-3 md:py-4 rounded-lg transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-calendar-check-line text-base md:text-lg"></i>
              견본주택 방문 예약
            </a>
            <a
              href="tel:1555-5475"
              onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion(); }}
              className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-bold text-[12px] md:text-[16px] px-6 md:px-8 py-3 md:py-4 rounded-lg transition-all cursor-pointer"
            >
              <i className="ri-phone-line text-base md:text-lg"></i>
              분양 문의 전화
            </a>
          </div>
          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6 text-white/60 text-[10px] md:text-[13px]">
            <div className="flex items-center gap-1.5 md:gap-2">
              <i className="ri-time-line text-yellow-300 text-sm"></i>
              <span>상담 운영시간 : 평일 09:00 ~ 18:00</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-white/20"></div>
            <div className="flex items-center gap-1.5 md:gap-2">
              <i className="ri-map-pin-line text-yellow-300 text-sm"></i>
              <span>견본주택 : 청주시 서원구 가경동 일원</span>
            </div>
          </div>
        </div>
      </section>

      {/* 모바일 고정 플로팅 CTA 바 */}
      <div className="fixed bottom-0 left-0 right-0 z-[90] md:hidden">
        <div className="h-[2px] bg-gradient-to-r from-[#b8972a] via-[#f0d060] to-[#b8972a] cta-glow"></div>
        <div className="bg-gradient-to-r from-[#0a1229] via-[#1a2b5c] to-[#0a1229] px-3 py-3 flex items-center gap-2.5 shadow-2xl">
          <Link
            to="/reservation"
            onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion(); }}
            className="flex-1 flex items-center justify-center gap-2 py-3.5 rounded-xl whitespace-nowrap cursor-pointer relative overflow-hidden group cta-pulse"
            style={{ background: 'linear-gradient(135deg, #b8972a 0%, #f0d060 40%, #c9a84c 70%, #b8972a 100%)' }}
          >
            <div className="absolute inset-0 bg-white/0 group-active:bg-white/10 transition-all"></div>
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute top-0 bottom-0 w-1/3 bg-gradient-to-r from-transparent via-white/40 to-transparent cta-shimmer"></div>
            </div>
            <i className="ri-calendar-check-line text-[#0a1229] text-[18px] relative z-10"></i>
            <span className="text-[14px] font-bold text-[#0a1229] relative z-10">방문예약</span>
          </Link>
          <a
            href="tel:1555-5475"
            onClick={() => { if (typeof (window as any).gtag_report_conversion === 'function') (window as any).gtag_report_conversion(); }}
            className="flex-1 flex items-center justify-center gap-2 py-3.5 bg-white rounded-xl whitespace-nowrap cursor-pointer relative overflow-hidden group border-2 border-white/30"
          >
            <div className="absolute inset-0 bg-[#1a2b5c]/0 group-active:bg-[#1a2b5c]/10 transition-all"></div>
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute top-0 bottom-0 w-1/3 bg-gradient-to-r from-transparent via-[#1a2b5c]/15 to-transparent cta-shimmer" style={{ animationDelay: '1.1s' }}></div>
            </div>
            <i className="ri-phone-fill text-[#1a2b5c] text-[18px] relative z-10"></i>
            <span className="text-[14px] font-bold text-[#1a2b5c] relative z-10">전화상담</span>
          </a>
        </div>
      </div>
    </div>
  );
}
